import clsx from 'clsx';
import { comboParts, formatCombo } from '@/lib/hotkeys';
import styles from './KeyHint.module.css';

export interface KeyHintProps {
  /** Hotkey combo in `lib/hotkeys` syntax, e.g. `"mod+shift+z"`, `"["`, `"1"`. */
  combo: string;
  className?: string;
}

/** Renders a shortcut as keycaps (platform aware: ⌘ on macOS, Ctrl elsewhere). */
export function KeyHint({ combo, className }: KeyHintProps) {
  return (
    <kbd className={clsx(styles.hint, className)} aria-label={formatCombo(combo)}>
      {comboParts(combo).map((part, i) => (
        <kbd key={i} className={styles.key} aria-hidden>
          {part}
        </kbd>
      ))}
    </kbd>
  );
}
